import endpoints from './endpoints.json';
//Url base de la API del CMS. Ejemplo https://cms.test/api
let API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default class API {
    constructor(axios) {
        this.axios = axios
    }

    /**
     * Cargar información del portal.
     */
    getPortalInfo() {
        return new Promise((resolve, reject) => {
            this.axios.post(endpoints.getPortalInfo)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    /**
     * Carga información del usuario si esta logueado.
     */
    getUserCookie() {
        return new Promise((resolve, reject) => {
            this.axios.post(endpoints.getUserCookie)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    /**
     * Iniciar sesión.
     * @param String Email o número de teléfono.
     * @param String Password.
     */
    login(email, password) {
        const postData = {
            email,
            password
        }
        return new Promise((resolve, reject) => {
            this.axios.post(endpoints.login, postData)
                .then(response => {
                    if (response.data.response == 200)
                        resolve(response.data.user_sesion)
                    else
                        reject(response.data.message)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    /**
     * Iniciar sesión.
     * @param String número de teléfono.
     */
    login_telefono(telefono, validarEntrada) {
        const postData = {
            telefono,
            validarEntrada
        }
        return new Promise((resolve, reject) => {
            this.axios.post(endpoints.login, postData)
                .then(response => {
                    if (response.data.response == 200)
                        resolve(response.data.user_sesion)
                    else
                        reject(response.data.message)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }


    /**
     * Cierra la sesión del usuario (elimina cookie).
     */
    logout() {
        return this.post(endpoints.logout, {})
    }

    /**
     * Llamada común al api, un post con data, devuelve una promesa que resuelve
     * si la respuesta es 200.
     * @param String url endpoint
     * @param Object postData (opcional)
     * @param Object headers (opcional)
     */
    post(endpoint, postData, headers) {
        return this.axios.post(endpoint, postData, headers)
    }

    /**
     * Llamada común al api, un get, devuelve una promesa que resuelve
     * si la respuesta es 200.
     * @param String url url
     * @param Object parameters (opcional)
     * @param Object headers (opcional)
     */
    get(endpoint, parameters, headers) {
        return this.axios.get(endpoint, parameters, headers)
    }

    updateUser(user) {
        return this.post(endpoints.updateUser, user)
    }

    updateUserPhoto(file) {
        let formData = new FormData()
        formData.append("foto", file)
        return this.post(endpoints.updateUserPhoto, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    getPagoUrl(params) {
        return this.post(endpoints.getPagoUrl, params)
    }

    getCategoriaContenido(id_categoria) {
        return this.post(endpoints.getCategoriaContenido, {
            id_categoria
        })
    }

    getUserCompras() {
        return this.get(endpoints.getUserCompras)
    }


    getUserComprasCache() {
        return this.get(endpoints.user_compra_solo)
    }

    getUserVideos() {
        return this.get(endpoints.getUserVideos)
    }

    getUserVideo(id_video) {
        return this.get(endpoints.getUserVideo + id_video)
    }

    videoProgreso(id_contenido_video, progreso) {
        console.log({
            id_contenido_video,
            progreso
        })
        return this.post(endpoints.videoProgreso, {
            id_contenido_video,
            progreso
        })
    }

    getPlayerEmbed(tipo, id) {
        return this.post(endpoints.player, {
            tipo,
            id
        })
    }

    deshabilitarDispositivo(id) {
        return this.post(endpoints.deshabilitarDispositivo, {
            id
        })
    }

    verificar_compra_pendiente(id_compra, numero, nombre, banco) {
        console.log({
            id_compra,
            numero,
            nombre,
            banco
        })
        return this.post(endpoints.verificar_compra_pendiente, {
            id_compra,
            numero,
            nombre,
            banco
        })
    }

    getPaginaInfo(guid) {
        return this.post(endpoints.getPaginaInfo, {
            guid
        })
    }


    getPaginaPortalInfoMenu() {
        return this.post(endpoints.getPaginaPortalInfoMenu)
    }

    landingPreWork(preWorkData) {
        return this.post(endpoints.landingPreWork, preWorkData)
    }

    operadorPreDetect() {
        return this.post(endpoints.operadorPreDetect)
    }

    registro(userData) {
        return this.post(endpoints.registro, userData)
    }

    registro2(userData) {
        return this.post(endpoints.registro2, userData)
    }

    olvido_password(userData) {
        return this.post(endpoints.olvido_password, userData)
    }

    restablecer_password(userData) {
        return this.post(endpoints.restablecer_password, userData)
    }

    activar_usuario(userData) {
        return this.post(endpoints.activar_usuario, userData)
    }


    get_temas_interes(userData) {
        return this.post(endpoints.get_temas_interes, userData)
    }


    temas_interes(userData) {
        return this.post(endpoints.temas_interes, userData)
    }


    descuentos(userData) {
        return this.post(endpoints.descuentos, userData)
    }


    users_regalo(userData) {
        return this.post(endpoints.users_regalo, userData)
    }

    detalle_compra(userData) {
        return this.post(endpoints.detalle_compra, userData)
    }


    estado_compra(userData) {
        return this.post(endpoints.estado_compra, userData)
    }


    envio_activar_usuario(userData) {
        return this.post(endpoints.envio_activar_usuario, userData)
    }

    setKlaviyoApi(userData) {
        return this.post(endpoints.setKlaviyoApi, userData)
    }

    pago_url_pin(userData) {
        return this.post(endpoints.pago_url_pin, userData)
    }


    service_json_movistar(userData) {
        return this.post(endpoints.service_json_movistar, userData)
    }

    service_json_movistar_encode(userData) {
        return this.post(endpoints.service_json_movistar_encode, userData)
    }

    service_terraEmpello_movistar(userData) {
        return this.post(endpoints.service_terraEmpello_movistar, userData)
    }

    service_setPinE_movistar(userData) {
        return this.post(endpoints.service_setPinE_movistar, userData)
    }
    service_json_movistar_decode(userData) {
        return this.post(endpoints.service_json_movistar_decode, userData);
    }
    guardarRespuestaTerra(userData) {
        return this.post(endpoints.guardarRespuestaTerra, userData);
    }
    service_token_movistar(userData) {
        return this.post(endpoints.service_token_movistar, userData)
    }

    movistar_header(userData) {
        return this.post(endpoints.movistar_header, userData)
    }

    event_klaviyo_suscribir(userData) {
        return this.post(endpoints.event_klaviyo_suscribir, userData)
    }

    service_ip_entel(userData) {
        return this.post(endpoints.service_ip_entel, userData)
    }


    service_ip_wom(userData) {
        return this.post(endpoints.service_ip_wom, userData)
    }


    service_idsession_entel(userData) {
        return this.post(endpoints.service_idsession_entel, userData)
    }


    action_suscripcion_operadores(userData) {
        return this.post(endpoints.action_suscripcion_operadores, userData)
    }

    event_klaviyo_referred(userData) {
        return this.post(endpoints.event_klaviyo_referred, userData)
    }


    operador(userData) {
        return this.post(endpoints.operador, userData)
    }

    otp(userData) {
        return this.post(endpoints.otp, userData)
    }

    otpValidate(userData) {
        return this.post(endpoints.otpValidate, userData)
    }

    hearderReq(userData) {
        return this.post(endpoints.hearderReq, userData)
    }

    hearderReq1(userData) {
        return this.post(endpoints.hearderReq1, userData)
    }

    proxyNotification(userData) {
        return this.post(endpoints.proxyNotification, userData)
    }
    entelInfo(userData) {
        return this.post(endpoints.entelInfo, userData)
    }
    hearderReqDatos(userData) {
        return this.post(endpoints.hearderReqDatos, userData)
    }
    datosProducto(userData) {
        return this.post(endpoints.datosProducto, userData)
    }
    inscribedByMobile(userData) {
        return this.post(endpoints.inscribedByMobile, userData)
    }
    entelSubscribe(userData) {
        return this.post(endpoints.entelSubscribe, userData)
    }
    entelConfirmar(userData) {
        return this.post(endpoints.entelConfirmar, userData)
    }

    empelloToken(userData) {
        return this.post(endpoints.empelloToken, userData)
    }
    entelDesbloqueo(userData) {
        return this.post(endpoints.entelDesbloqueo, userData)
    }
    obtenerUser(userData) {
        return this.post(endpoints.obtenerUser, userData)
    }

    proxyUser(userData) {
        return this.post(endpoints.proxyUser, userData)
    }

    cambiar_curso_seleccionado(userData) {
        return this.post(endpoints.cambiar_curso_seleccionado, userData)
    }

    url_curso_decode(userData) {
        return this.post(endpoints.url_curso_decode, userData)
    }
    true_or_false(userData) {
        return this.post(endpoints.true_or_false, userData)
    }
}
